import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import {
	Accordion,
	AccordionDetails,
	AccordionSummary,
	Box,
	TextField,
	Typography
} from '@mui/material'
import { Stack, styled } from '@mui/system'
import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import SlAmountComponent from './SlAmountComponent'
import TpAmountComponent from './TpAmountComponent'
import { useDefaultComponentTools } from '../../../../../hooks/useDefaultComponentTools'
import {
	setExecutionEntryRate,
	setStateStopLoss,
	setStateTakeProfit
} from '../../../../../store/redusers/orders/actions'
import {
	selectExecutionEntryRate,
	selectStopLoss,
	selectTakeProfit
} from '../../../../../store/redusers/orders/selectors'
import {selectUserCurrency} from '../../../../../store/redusers/user/selectors'

export const SidebarBasicTitle = styled(Typography)(({ theme }) => ({
	color:  theme.palette.mode === 'dark' ? '#FFFFFF' : '#131635',
	fontSize: '18px',
	[theme.breakpoints.down('md')]: {
		fontSize: '14px'
	}
}))
export const TextFieldSlTp = styled(TextField)(({ theme }) => ({
	'.MuiInputBase-input': {
		fontSize: '18px',
		padding: '12px',
		textAlign: 'end',
		[theme.breakpoints.down('md')]: {
			fontSize: '14px',
			padding: '8px'
		}
	},
	background: theme.palette.second,
	border: 0,
	borderRadius: '4px',
	'input': {
		color: theme.palette.text.primary
	},
	width: '100%'
}))

function SidebarInitActionsSlTp({
	isOpenTradeTab,
	stopLossAmount,
	takeProfitAmount,
	takeProfitUpdate,
	setTakeProfitSend,
	stopLossUpdate,
	setStopLossSend,
	position,
	updateSlTp,
	assetId,
	myId,
	lastPrice,
	isSuccessOpenTrade,
	setIsSuccessCreate,
	pendingPosition
}) {
	const { dispatch, theme, t } = useDefaultComponentTools()
	const executionEntryRate = useSelector(selectExecutionEntryRate)
	const userCurrency = useSelector(selectUserCurrency)
	const [ executionRate, setExecutionRate ] = useState(executionEntryRate)
	const [ expanded, setExpanded ] = useState(true)
	const [ takeProfit, setTakeProfit ] = useState(takeProfitUpdate)
	const [ stopLoss, setStopLoss ] = useState(stopLossUpdate)

	useEffect(() => {
		setTakeProfit(takeProfitUpdate)
		setStopLoss(stopLossUpdate)
	}, [takeProfitUpdate, stopLossUpdate])

	useEffect(() => {
		setExecutionRate(executionEntryRate)
	}, [executionEntryRate])

	const handleChange = () => {
		setExpanded(!expanded)
	}

	useEffect(() => {
		dispatch(setStateTakeProfit(takeProfit))
	}, [takeProfit])

	useEffect(() => {
		dispatch(setStateStopLoss(stopLoss))
	}, [stopLoss])

	useEffect(() => {
		if(stopLossAmount) return
		setStopLoss('')
	}, [stopLossAmount])

	useEffect(() => {
		if(takeProfitAmount) return
		setTakeProfit('')
	}, [takeProfitAmount]	)

	const handleChangePrice = (event) => {
		dispatch(setExecutionEntryRate(event.target.value))
	}

	return (
		<Stack>
			{isOpenTradeTab ? null : <Box>
				<SidebarBasicTitle sx={{mb: '4px'}}>{t('Price')}</SidebarBasicTitle>
				<TextFieldSlTp
					type='number'
					value={executionRate}
					inputProps={{ 'aria-label': 'Without label' }}
					sx={{ mb: 2 }}
					name={'price'}
					color={'error'}
					onChange={e => handleChangePrice(e)}
				/>
			</Box>
			}
			<Accordion
				disableGutters
				expanded={expanded}
				onChange={handleChange}
				sx={{  background: theme.palette.background, boxShadow: 'none' }}>
				<AccordionSummary
					expandIcon={
						<KeyboardArrowDownIcon sx={{color: theme.palette.text.secondary}}/>
					}
					aria-controls='panel1a-content'
					id='panel1a-header'
					value='SL/TP'
					sx={{ p: 0 }}
				>
					<SidebarBasicTitle>{t('SL/TP')}</SidebarBasicTitle>
				</AccordionSummary>
				<AccordionDetails sx={{ p: 0 }}>
					<SlAmountComponent
						key={'sl' + myId || 'sl' + assetId}
						userCurrency={userCurrency}
						stopLossAmount={stopLossAmount}
						updateSlTp={updateSlTp}
						setStopLossSend={setStopLossSend}
						position={position}
						assetId={assetId}
						stopLossUpdate={stopLossUpdate}
						lastPrice={lastPrice || executionRate}
						isSuccessOpenTrade={isSuccessOpenTrade}
						setIsSuccessCreate={setIsSuccessCreate}
						pendingPosition={pendingPosition}
					/>
					<TpAmountComponent
						key={'tp' + myId || 'tp' + assetId}
						userCurrency={userCurrency}
						takeProfitAmount={takeProfitAmount}
						updateSlTp={updateSlTp}
						setTakeProfitSend={setTakeProfitSend}
						position={position}
						assetId={assetId}
						takeProfitUpdate={takeProfitUpdate}
						lastPrice={lastPrice || executionRate}
						isSuccessOpenTrade={isSuccessOpenTrade}
						setIsSuccessCreate={setIsSuccessCreate}
						pendingPosition={pendingPosition}
					/>
				</AccordionDetails>
			</Accordion>
		</Stack>
	)
}

SidebarInitActionsSlTp.propTypes = {
	assetId: PropTypes.any,
	endRate: PropTypes.any,
	isOpenTradeTab: PropTypes.bool,
	isSuccessOpenTrade: PropTypes.bool,
	lastPrice: PropTypes.any,
	myId: PropTypes.any,
	openPosition: PropTypes.any,
	pendingPosition: PropTypes.any,
	position: PropTypes.any,
	setIsSuccessCreate: PropTypes.func,
	setStopLossSend: PropTypes.func,
	setTakeProfitSend: PropTypes.func,
	stopLossAmount: PropTypes.any,
	stopLossUpdate: PropTypes.any,
	takeProfitAmount: PropTypes.any,
	takeProfitUpdate: PropTypes.any,
	updateSlTp: PropTypes.func
}

export default SidebarInitActionsSlTp
